import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import esse9 from "../../../components/tables/esse-posse-9";
import esse10 from "../../../components/tables/esse-posse-10";
import esse11 from "../../../components/tables/esse-posse-11";
import esse29 from "../../../components/tables/esse-posse-29";
import esse43 from "../../../components/tables/esse-posse-43";
import esse from "../../../components/tables/esse-posse";
const data = [
  {
    les: "9",
    table: esse9
  },
  {
    les: "10",
    table: esse10
  },
  {
    les: "11",
    table: esse11
  },
  {
    les: "29",
    table: esse29
  },
  {
    les: "43",
    table: esse43
  },
  {
    les: "44",
    table: esse
  }
];

export default () => (
  <TableSelector defaultChapter="44" data={data} title="Esse & posse" />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/esse-posse.js